module.exports = __webpack_public_path__ + "static/media/video4.8458b403.jpg";